import React from 'react';
import { Section } from './ui/Section';
import { useCountUp } from '../hooks/useCountUp';
import { motion } from 'framer-motion';
export default function PainSection() {
  const {
    count,
    ref
  } = useCountUp(47, 2000, true);
  return <Section className="bg-brand-cream-dark relative overflow-hidden" data-id="element-269">
      {/* Subtle night-anxiety gradient wash */}
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} transition={{
      duration: 1.5
    }} className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-navy/30 to-transparent pointer-events-none" data-id="element-270" />

      {/* Abstract soft blobs */}
      <div className="absolute -right-20 -top-20 w-72 h-72 bg-brand-indigo/10 rounded-full blur-3xl pointer-events-none" data-id="element-271" />
      <div className="absolute -left-16 bottom-0 w-56 h-56 bg-brand-amber/5 rounded-full blur-3xl pointer-events-none" data-id="element-272" />
      <div className="absolute right-1/4 bottom-1/4 w-40 h-40 bg-red-900/10 rounded-full blur-2xl pointer-events-none" data-id="element-273" />

      <div className="relative z-10" data-id="element-274">
        <h2 className="font-heading text-4xl md:text-5xl text-white mb-12 text-center uppercase tracking-wide" data-id="element-275">
          Tu problema no es dormir.{' '}
          <span className="text-brand-amber" data-id="element-276">Es la pelea.</span>
        </h2>

        <div className="text-center mb-16" ref={ref} data-id="element-277">
          <div className="text-6xl md:text-8xl font-bold text-white mb-2 tabular-nums leading-none" data-id="element-278">
            {count}
          </div>
          <p className="text-xl text-brand-indigo font-medium uppercase tracking-widest" data-id="element-279">
            minutos promedio despierto
          </p>
          <p className="text-slate-500 text-sm" data-id="element-280">
            peleando con tu mente en la cama
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-281">
          <div className="space-y-6" data-id="element-282">
            <p className="text-xl text-slate-400" data-id="element-283">
              Lo que te drena no es estar despierto. Es esto:
            </p>
            <ul className="space-y-4" data-id="element-284">
              {['engancharte a pensamientos,', 'repasar pendientes,', 'anticipar el día siguiente,', 'intentar relajarte (y fracasar),', 'culparte por no poder dormir.'].map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: i * 0.1
            }} className="flex items-center text-2xl md:text-3xl font-heading text-slate-200 uppercase tracking-wide" data-id="element-285">
                  <span className="w-3 h-3 bg-brand-indigo rounded-full mr-4 shadow-[0_0_12px_rgba(99,102,241,0.6)] animate-pulse" data-id="element-286" />
                  {item}
                </motion.li>)}
            </ul>
          </div>

          <div className="bg-brand-navy/50 p-8 rounded-2xl border border-white/10 shadow-lg backdrop-blur-sm" data-id="element-287">
            <p className="text-xl md:text-2xl text-slate-400 leading-relaxed mb-6" data-id="element-288">
              Todos los días. A las 11pm tu mente no está disponible para
              descansar.
            </p>
            <p className="text-xl md:text-2xl text-slate-200 font-medium leading-relaxed" data-id="element-289">
              Y ahí es cuando ganas «la solución rápida» (celular, dar vueltas,
              frustración) y pierdes lo que de verdad quieres:{' '}
              <span className="text-brand-indigo underline decoration-2 underline-offset-4 font-bold" data-id="element-290">
                calma
              </span>
              .
            </p>
          </div>
        </div>
      </div>
    </Section>;
}